module.exports = __webpack_public_path__ + "img/logo-en.5b36bb03.png";